import api from 'js/api'
export const getUserProfile = () => {
  return Promise.all([
    api('GET', 'userprofile/v1/me', undefined, { cache: 'no-store' }),
    api('GET', 'v2/store/subscription'),
  ]).then(([profile, { response }]) => {
    return { ...profile, ...response }
  })
}
